import { VariantVisibility } from "../../models/src/elements/variant-visibility";

interface GetPathVariantParams {
  variant: string | undefined | null;
  variantInPath?: VariantVisibility | null;
  type?: string;
}

export const getPathVariant = (params: GetPathVariantParams): string => {
  let { variant, variantInPath, type } = params;

  variantInPath = variantInPath || VariantVisibility.VISIBLE;
  type = type || "page";

  if (variantInPath && variantInPath === VariantVisibility.HIDDEN) {
    return "";
  }

  if (!variant) {
    return "";
  }

  if (!variant) {
    return "";
  }

  if (variant.includes("not_applicable")) {
    return "";
  }

  if (variant.length < 1) {
    return "";
  }

  if (type === "repo") {
    return `_${variant}`;
  }

  return `-with-${variant}`;
};
